import Card from "components/card";
import {
  lineChartDataTotalSpent,
  lineChartOptionsTotalSpent,
} from "variables/charts";
import LineAreaChart from "components/charts/LineAreaChart";

const TransactionChart = () => {
  return (
    <Card extra="pt-5 text-center">
      <div className="ml-[-6px] md:ml-1 h-full w-[107.5%] md:w-full">
        <p className="px-4 text-large text-left mt-3">Transaction History in 14 Days</p>
        <div className="mt-[-24px]">
          <LineAreaChart
            chartOptions={lineChartOptionsTotalSpent}
            chartData={lineChartDataTotalSpent}
          />
        </div>
      </div>
    </Card>
  );
};

export default TransactionChart;
